import React from 'react'
import {Input} from "../../../../components/Input/Input";

const SingleInputForm = (
    props: { input: string, inputName: string, inputType: string, required: boolean, prompt: string, setInput: Function, onSubmit: Function }) => {

    return (
        <>
            <form className="mt-8" onSubmit={(e) => e.preventDefault()}>

                <div className="-space-y-px rounded-md shadow-sm">
                    <div>
                        <label htmlFor="email" className="large-label">{props.prompt}</label>
                        <input id={props.inputName} name={props.inputName} type={props.inputType}
                               required={props.required}
                               value={props.input}
                               className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                onChange={(e) => props.setInput(e.target.value)}/>
                    </div>
                </div>
                <br/>

                <div>
                    <button type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" onClick={() => props.onSubmit()}>
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <svg className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                                d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                                clip-rule="evenodd"/>
                        </svg>
                      </span>
                        Submit
                    </button>
                </div>
            </form>
        </>
    )
}

export default SingleInputForm;